module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-5.ed1bf084.svg";